import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { Modal, Backdrop, Fade } from '@mui/material';
import APHeading from "../../atoms/APHeading";
import APRocketProgress from "../../atoms/APRocketProgress";
import { withTranslate } from "../../../core/TenantProvider";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            borderRadius: 12,
            boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.08)",
            backgroundColor: "#fff",
            textAlign: "center",
            padding: "69px 138px 74px",
            outline: 'none',
            opacity: '0.99 !important',
            [theme.breakpoints.down('md')]: {
                padding: "69px 64px 74px",
            },
        },
        panel: {
            "& p": {
                fontfamily: "CircularStd",
                color: "#a4a4a4",
                marginTop: 38,
                fontSize: 16,
                [theme.breakpoints.down('md')]: {
                    fontSize: 12,
                    width: 246,
                },
            },
        },
        modalHeader: {
            marginBottom: 40,
            [theme.breakpoints.down('md')]: {
                width: 246,
            },
        },
        rocketProgress: {
            margin: "0 auto",
            width: 220,
            height: 196
        },
    }),
);

function APFadeOverlayModal(props: any) {
    const classes = useStyles();
    const { translate, pollingProgress, open } = props;

    return (
        <Modal
            aria-labelledby="Checking if client identity needed"
            aria-describedby="Checking if client identity needed"
            className={classes.modal}
            open={open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <div className={classes.paper}>
                    <div className={classes.panel}>
                        <APHeading className={classes.modalHeader} variant="h4">
                            {translate('register.customer.modal.title')}
                        </APHeading>
                        <div className={classes.rocketProgress}>
                            <APRocketProgress progress={pollingProgress} />
                        </div>
                        <p>{translate('register.customer.modal.paragraph')}</p>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}

export default withTranslate(APFadeOverlayModal);